<div class="tagProductDs__cont tagProductDs__cont--{{type}}">
  <ng-container *ngTemplateOutlet="useIcon ? iconTemplate : iformativeTemplate"></ng-container>
  <div class="tagProductDs__information tagProductDs__information--{{type}}">
    <ng-container *ngIf="title">
      <div class="tagProductDs__title">
        <app-ds-typography
          [text]="title"
          [fontFamily]="fontFamily.SemiBold"
          [size]="fontSize.XXXS"
          [color]="fontColor">
        </app-ds-typography>
      </div>
    </ng-container>
    <ng-container *ngIf="useSubtitle">
      <div class="tagProductDs__subtitle">
        <app-ds-typography
          [text]="subtitle"
          [fontFamily]="fontFamily.Regular"
          [size]="fontSize.XXXS"
          [color]="fontColor">
        </app-ds-typography>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #iformativeTemplate>
  <ng-container *ngIf="brandIcon">
    <div class="tagProductDs__image tagProductDs__image--branding-{{branding}}">
      <app-ds-icon
        [icon]="brandIcon"
        [color]="brandIconColor"
        [size]="brandIconSize">
      </app-ds-icon>
    </div>
  </ng-container>
</ng-template>

<ng-template #iconTemplate>
  <ng-container *ngIf="tagIcon">
    <div class="tagProductDs__icon">
      <app-ds-icon
        [icon]="tagIcon"
        [size]="iconSize"
        [color]="iconFillColor">
      </app-ds-icon>
    </div>
  </ng-container>
</ng-template>
